import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Transition } from "@headlessui/react";
import { MenuIcon } from "@heroicons/react/solid";
import { useCurrentWidth } from "./Helper/WidthHook";
import routes from "../SideBarRoutes";
import SidebarContent from "./SideBar/SidebarContent";

export default function SideBar(props) {
  const dispatch = useDispatch();
  const userSelector = useSelector((state) => state.user);
  const currentPath = useLocation().pathname;
  const [expanded, setExpanded] = useState(false);
  const matches = useCurrentWidth();

  return (
    <>
      {matches ? (
        <div className="flex flex-col z-10 h-full w-72 min-w-72 bg-white dark:bg-gray-800">
          <SidebarContent />
        </div>
      ) : (
        <div className="z-10 w-screen h-14 justify-center bg-gray-200 flex-row flex dark:bg-gray-800">
          <img
            src="https://static.tvtropes.org/pmwiki/pub/images/a1.jpg"
            className="w-48 object-cover rounded-lg"
          />
          <MenuIcon
            className="absolute right-0 rounded-md h-10 w-10 p-1 m-2 bg-gray-300"
            onClick={() => setExpanded(!expanded)}
          ></MenuIcon>
          <MobileSidebar
            isSidebarOpen={expanded}
            closeSidebar={() => setExpanded(!expanded)}
          />
        </div>
      )}
    </>
  );
}

function MobileSidebar(props) {
  return (
    <Transition show={props.isSidebarOpen}>
      <>
        <Transition
          enter="transition ease-in-out duration-150"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition ease-in-out duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <input
            type="button"
            className="absolute left-0 w-screen h-screen z-20 bg-gray-50 bg-opacity-75"
            onClick={props.closeSidebar}
          />
        </Transition>

        <Transition
          enter="transition ease-in-out duration-150"
          enterFrom="opacity-0 transform -translate-x-20"
          enterTo="opacity-100"
          leave="transition ease-in-out duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0 transform -translate-x-20"
        >
          <aside className="absolute left-0 h-full z-50 w-64 overflow-y-auto bg-white dark:bg-gray-800">
            <SidebarContent />
          </aside>
        </Transition>
      </>
    </Transition>
  );
}
